"use client";

import { useQuery } from "@tanstack/react-query";

import { rewardsService } from "../services/rewards.service";
import type { WinsSinceVisitResponse } from "../types";

/**
 * Claim the wins-since-visit certificate stack exactly once per app session.
 *
 * The queryFn POSTs (the claim advances the server-side visit stamp), so this
 * query must never refetch on its own: staleTime/gcTime Infinity, every
 * automatic refetch trigger off. A hard refresh re-claims — and correctly
 * gets an empty stack, because the stamp already advanced.
 */
export const WINS_SINCE_VISIT_QUERY_KEY = ["rewards", "wins-since-visit"] as const;

export function useWinsSinceVisit(enabled: boolean = true) {
  return useQuery<WinsSinceVisitResponse>({
    queryKey: WINS_SINCE_VISIT_QUERY_KEY,
    queryFn: () => rewardsService.claimWinsSinceVisit(),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
  });
}
